import styled from '@emotion/styled/macro'

import { flexCenter } from 'style/emotion'

const GoBackHeaderContainer = styled('section')`
  ${flexCenter}

  background-color: var(--print-main);
  height: auto;
  justify-content: space-between;
  padding: 10px 8px 10px 8px;
  position: relative;
  cursor: pointer;
`

const GoBackHeaderBtn = styled('div')`
  ${flexCenter}

  color: white;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 300;
  height: auto;
  justify-content: flex-start;
  width: auto;

  > span {
    margin-right: 8px;
  }

  > p {
    text-align: left;
    margin: 0;
  }
`

export { GoBackHeaderBtn, GoBackHeaderContainer }
